import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define a type for the slice state
interface IconsState {
  iconsStore: Array<{
    contentFile: string;
    formatFile: any;
    id: number;
    nameFile: any;
  }>;
  poiCategoryIcons?: any[];
}

// Define the initial state using that type
const initialState: IconsState = {
  iconsStore: (function getIcons() {
    return JSON.parse(localStorage.getItem('icons') || '[]');
  })(),
  poiCategoryIcons: [],
};

export const iconsSlices = createSlice({
  name: 'iconsSlices',
  initialState,
  reducers: {
    updateIcons: (state, action) => {
      if (action.payload) {
        try {
          // Filtramos los iconos que no están en el array actual
          const newIcons = action.payload.filter(
            (newIcon: { id: number }) =>
              !state.iconsStore.some((existingIcon) => existingIcon.id === newIcon.id)
          );

          // Agregamos solo los iconos que no están duplicados
          state.iconsStore = [...state.iconsStore, ...newIcons];
          localStorage.setItem('icons', JSON.stringify(state.iconsStore));
        } catch (error) {
          console.error('No se pudo cargar los iconos en el storage');
        }
      }
    },
    updateIcon: (state, action) => {
      try {
        // Verificamos si el icono ya existe en el array
        const iconExists = state.iconsStore.some((icon) => icon.id === action.payload.id);

        // Si no existe, lo agregamos
        if (!iconExists) {
          state.iconsStore.push(action.payload);
          localStorage.setItem('icons', JSON.stringify(state.iconsStore));
        }
      } catch (error) {
        console.error('No se pudo cargar el icono en el storage');
      }
    },
    updatePoiCategoryIcons: (state, action) => {
      state.poiCategoryIcons = action.payload;
    },
  },
});

export const { updateIcons, updateIcon, updatePoiCategoryIcons } = iconsSlices.actions;

// Other code such as selectors can use the imported `RootState` type
export const iconsState = (state: RootState) => state.icons.iconsStore;
export const poiCategoryIconsState = (state: RootState) => state.icons.poiCategoryIcons;

export default iconsSlices.reducer;
